import { getDisplayMode } from '../../../utils/pwaUtils';

export const usePWADisplay = () => {
  const displayMode = getDisplayMode();
  const isIOSSafari = displayMode === 'ios-safari';

  return {
    displayMode,
    isIOSSafari
  };
}; 